const DEFAULT_OPERATION = 'defaultOperation';
const SAVE_OPERATION = 'saveOperation';
const CANCEL_OPERATION = 'cancelOperation';

export {
  DEFAULT_OPERATION,
  SAVE_OPERATION,
  CANCEL_OPERATION,
};
